<template>
  <a-card :bordered="false">
    <div class="editable-add-btn">
      <a-button type="primary" icon="plus" @click="handleAdd" style="margin-bottom:10px;">新增</a-button>
      <a-button style="margin-left: 8px" :disabled="this.selectedRowKeys.length == 0" @click="handleBatchDel">批量删除
        <a-icon type="delete" />
      </a-button>
    </div>
    <s-table
      rowKey="announceId"
      :columns="columns"
      :data="loadData"
      ref="table"
      :loading="loading"
      :alert="options.alert"
      :rowSelection="options.rowSelection">

      <span slot="serial" slot-scope="text, record, index" >{{ index + 1 }}</span>

      <span
        slot="announceSummary"
        slot-scope="text"
      >
        <ellipsis
          :length="60"
          tooltip
        >
          {{ text }}
        </ellipsis>
      </span>
      <span slot="announceReceiver" slot-scope="tags">
        <span v-for="announceReceiver in tags" :key="announceReceiver" >
          <a-tag color="blue" v-if="announceReceiver != ','" >
            {{ announceReceiver | receiverFilter }}
          </a-tag>
        </span>
      </span>
      <span slot="updateDate" slot-scope="text">{{ text | parseTime('{y}-{m}-{d} {h}:{i}') }}</span>
      <span slot="action" slot-scope="record">
        <a @click="showDrawer(record)">详情</a>
        <a-divider type="vertical" />
        <a-popconfirm
          title="此操作将永久删除, 是否继续?"
          okText="确定"
          cancelText="取消"
          @confirm="() => handleDelConfirm(record.announceId)">
          <a href="javascript:;">删除</a>
        </a-popconfirm>
      </span>
    </s-table>
    <a-drawer
      :title="addStatus ? '详情' : '新增'"
      :width="750"
      @close="onClose"
      :visible="visible"
      :wrapStyle="{height: 'calc(100% - 108px)',overflow: 'auto',paddingBottom: '108px'}" >
      <a-spin :spinning="loading">

        <a-form layout="vertical" :form="form">
          <a-form-item
            v-show="false"
            hasFeedback >
            <a-input v-decorator="[ 'announceId', {rules: []} ]"/>
          </a-form-item>
          <a-form-item label="公告概要" hasFeedback>
            <a-input :disabled="disable" placeholder="请输入公告概要" v-decorator="[ 'announceSummary', {rules: [{ required: true, message: '必须输入' },{max:20,message:'输入内容不能超过20个字'}]} ]"/>
          </a-form-item>
          <a-form-item label="公告内容" :required="true" hasFeedback>
            <quill-editor
              :disabled="disable"
              style="  line-height: normal !important;height: 300px;margin-bottom: 50px;"
              ref="myQuillEditor"
              v-model="formData.announceContent"
              @change="onEditorChange($event)">
            </quill-editor>
          </a-form-item>
          <a-form-item label="接收方" :required="true" >
            <a-checkbox-group :disabled="disable" style="width: 100%;" v-model="checked">
              <a-checkbox value="3">教师端</a-checkbox>
              <a-checkbox value="4">学生端</a-checkbox>
            </a-checkbox-group>
          </a-form-item>
        </a-form>
        <div style="margin-top:200px;padding-top:50px">
          <div v-if="this.flag" :style="{position: 'absolute',left: 0,bottom: 0,width: '100%',borderTop: '1px solid #e9e9e9',padding: '10px 16px',background: '#fff',textAlign: 'right',}">
            <a-button :style="{marginRight: '8px'}" @click="onClose">取消</a-button>
            <a-button type="primary" @click="handleSubmit">提交</a-button>
          </div>
          <div v-if="!this.flag" :style="{position: 'absolute',left: 0,bottom: 0,width: '100%',borderTop: '1px solid #e9e9e9',padding: '10px 16px',background: '#fff',textAlign: 'right',}">
            <a-button :style="{marginRight: '8px'}" @click="onClose">取消</a-button>
          </div>
        </div>
      </a-spin></a-drawer>
  </a-card>
</template>
<script>

import STable from '@/components/table2/'
import { quillEditor } from 'vue-quill-editor'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
import { addObj, delObj, getAnnouncementList, putObj, getObj, delBatchObj } from '@/api/message/notice'
import { richTextCorrect, SixteenToRGB } from '@/api/text/text'

import Ellipsis from '@/components/Ellipsis'
const columns = [
  { title: '序号', align: 'center', scopedSlots: { customRender: 'serial' } },
  { title: '公告概要', dataIndex: 'announceSummary', scopedSlots: { customRender: 'announceSummary' } },
  { title: '接收方', align: 'center', dataIndex: 'announceReceiver', scopedSlots: { customRender: 'announceReceiver' } },
  { title: '创建时间', dataIndex: 'updateDate', scopedSlots: { customRender: 'updateDate' } },
  { title: '操作', key: 'action', scopedSlots: { customRender: 'action' } }]
export default {
  name: 'Announcement',
  components: {
    STable,
    quillEditor,
    Ellipsis
  },
  data () {
    return {
      addStatus: false,
      flag: false,
      formData: {},
      columns,
      pagination: {},
      loading: false,
      visible: false,
      confirmLoading: false,
      contentVisible: false,
      queryParam: {},
      checked: [],
      disable: false,
      form: this.$form.createForm(this),
      formItemLayout: {
        labelCol: { span: 6 },
        wrapperCol: { span: 14 }
      },
      selectedRowKeys: [],
      selectedRows: [],
      options: {
        alert: { show: true, clear: () => { this.selectedRowKeys = [] } },
        rowSelection: {
          selectedRowKeys: this.selectedRowKeys,
          onChange: this.onSelectChange
        }
      },
      optionAlertShow: true,
      loadData: parameter => {
        return getAnnouncementList(Object.assign(parameter, this.queryParam)).then(res => {
          return res.result
        })
      }
    }
  },
  filters: {
    receiverFilter (announceReceiver) {
      const receiverMap = {
        '3': '教师端',
        '4': '学生端'
      }

      var a = announceReceiver.split(',')
      var b = []
      for (var i = 0; i < a.length; i++) {
        b.push(receiverMap[a[i]])
      }
      return b.toString()
    }
  },
  created () {

  },
  methods: {
    onEditorChange ({ editor, html, text }) {
      this.formData.announceContent = html
    },
    showDrawer (record) {
      this.addStatus = true
      this.visible = true
      if (record.announceId == null) {
        this.flag = true
        this.disable = false
      } else {
        this.flag = false
        this.disable = true
      }
      getObj(record.announceId).then(res => {
        this.formData = res.result
        this.formData.announceContent = SixteenToRGB(this.formData.announceContent)
        this.form.setFieldsValue(this.formData,
          'announceId', 'announceSummary', 'announceContent', 'announceReceiver')
        this.checked = this.formData.announceReceiver
      })
    },
    handleOk () {
      this.$refs.table.refresh()
    },
    onClose () {
      this.visible = false
      this.loading = false
    },
    showContent () {
    },
    onDelete () {
    },
    handleAdd () {
      this.checked = []
      this.flag = true
      this.disable = false
      this.formData = {}
      this.addStatus = false
      this.visible = true
      this.form.resetFields()
    },
    handleSubmit (e) {
      e.preventDefault()
      const _this = this
      this.form.validateFieldsAndScroll((err, values) => {
        values.announceContent = richTextCorrect(_this.formData.announceContent)
        values.announceReceiver = this.checked.toString()
        if (!err) {
          if (_this.addStatus) {
            this.loading = true
            putObj(values).then(() => {
              _this.$message.success('更新成功')
              _this.$refs.table.refresh()
            }).catch(() => {
              _this.$message.error('更新失败')
            }).finally(() => {
              _this.onClose()
            })
          } else {
            if (values.announceContent == null || values.announceReceiver === '') {
              this.$message.error('公告内容或接收方不能为空')
            } else {
              this.loading = true
              addObj(values).then(() => {
                _this.$message.success('保存成功')
                _this.$refs.table.refresh()
              }).catch(() => {
                _this.$message.error('保存失败')
              }).finally(() => {
                _this.onClose()
              })
            }
          }
        }
      })
    },
    onSelectChange (selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
    },
    handleDelConfirm (key) {
      delObj(key).then(() => {
        this.$refs.table.refresh()
        this.selectedRowKeys = []
        this.selectedRows.length = 0
        this.$message.success('删除成功', 10)
      })
    },
    clickHandler () {
      var ids = this.selectedRows.map(item => item.announceId).join()
      delBatchObj(ids).then(() => {
        this.$refs.table.refresh()
        this.selectedRowKeys = []
        this.selectedRows.length = 0
        this.$message.success('删除成功', 10)
      }).catch(() => {
        this.$message.error('删除失败')
      })
    },
    handleBatchDel () {
      this.$confirm({
        title: '是否确认删除所有选择项?',
        content: '批量删除所有选中项',
        okText: '是',
        okType: 'danger',
        cancelText: '否',
        okButtonProps: {
          on: {
            click: this.clickHandler
          }
        },
        onCancel () {
          console.log('Cancel')
        }
      })
    }
  }
}
</script>
<style>
.editable-add-btn {
  margin-bottom: 15px;
}
.editable-add-btn > button {
  margin-right: 15px;
}
</style>
